module.exports = __webpack_public_path__ + "img/i1.cbf08eda.jpg";